import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { StaffRequest } from '../../lib/types/models/staff-request/staff-request'
import { StaffRequestFilters } from '../../lib/types/models/staff-request/staff-request-input'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getStaffRequests(input: PaginationRequest<StaffRequestFilters> = {}) {
  return restApiClient
    .url(encodeNestedObject(API.staffRequest.getAll.url, input))
    .get<PaginationResponse<StaffRequest>>()
}
